import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["paymentAmountInput", "addPaymentButton"]

  connect() {
    this.toggleAddPaymentButton()
  }

  toggleAddPaymentButton() {
    if (!this.hasAddPaymentButtonTarget || !this.hasPaymentAmountInputTarget) return

    const paymentAmountValue = Number(this.paymentAmountInputTarget.value.replace(/[^0-9\.-]+/g, ""))

    if (paymentAmountValue === 0) {
      this.addPaymentButtonTarget.disabled = true
    }
    else {
      this.addPaymentButtonTarget.disabled = false
    }
  }
}
